import { render, staticRenderFns } from "./SearchAnalysis.vue?vue&type=template&id=01f9b274"
import script from "./SearchAnalysis.vue?vue&type=script&lang=js"
export * from "./SearchAnalysis.vue?vue&type=script&lang=js"
import style0 from "./SearchAnalysis.vue?vue&type=style&index=0&id=01f9b274&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports